import { render } from "./workpermitdetails.vue?vue&type=template&id=1a79c98d&scoped=true"
import script from "./workpermitdetails.vue?vue&type=script&lang=js"
export * from "./workpermitdetails.vue?vue&type=script&lang=js"

import "./workpermitdetails.vue?vue&type=style&index=0&id=1a79c98d&scoped=true&lang=css"
import "./workpermitdetails.vue?vue&type=style&index=1&id=1a79c98d&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1a79c98d"]])

export default __exports__